import { LOCALSTORAGE_LAST_ROUTE_KEY } from 'hooks/useAuth';

export const getLastRoute = () => {
	let lastRoute;
	try {
		const storage = window.localStorage.getItem(LOCALSTORAGE_LAST_ROUTE_KEY);
		lastRoute = storage ? JSON.parse(storage) : lastRoute;
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('failed to read from local storage', e);
	}
	return lastRoute;
};

export const resetLastRoute = () => {
	window.localStorage.setItem(LOCALSTORAGE_LAST_ROUTE_KEY, '');
};
